import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addTrello } from '../../actions/userActions';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import classnames from 'classnames';

const TrelloAddModal = ({ addTrello, auth, errors, getData }) => {
    const [state, setState] = useState({
        appKey: '',
        userToken: '',
        errors: {},
    });

    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            errors,
        }));
    }, [errors]);

    const onChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    const hideModal = () => {
        $('#add-trello-modal').modal('hide');
    };

    const onTrelloAdd = (e) => {
        e.preventDefault();
        let email = localStorage.getItem("email")
        const newUser = {
            appKey: state.appKey,
            userToken: state.userToken,
            email: email,
        };
        

        addTrello(newUser, getData, hideModal);
    };

    return (
        <div>
            <div className="modal fade" id="add-trello-modal" data-reset="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Trello</h4>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                            >
                                &times;
                            </button>
                        </div>
                        <div className="modal-body">
                            <form noValidate onSubmit={onTrelloAdd} id="add-user">
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="name">Application key</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            onChange={onChange}
                                            value={state.appKey}
                                            id="appKey"
                                            type="text"
                                            error={state.errors.appKey}
                                            className={classnames('form-control', {
                                                invalid: state.errors.appKey,
                                            })}
                                        />
                                        <span className="text-danger">{state.errors.appKey}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="name">User Token</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                            onChange={onChange}
                                            value={state.userToken}
                                            id="userToken"
                                            type="text"
                                            error={state.errors.userToken}
                                            className={classnames('form-control', {
                                                invalid: state.errors.userToken,
                                            })}
                                        />
                                        <span className="text-danger">{state.errors.userToken}</span>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                form="add-user"
                                type="submit"
                                className="btn btn-primary"
                            >
                                Add Trello
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

TrelloAddModal.propTypes = {
    addTrello: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    getData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
});

export default connect(mapStateToProps, { addTrello })(
    withRouter(TrelloAddModal)
);
